











































import { Component, Vue } from "vue-property-decorator";
import { SelectorMap } from "@/utility/TemplateOptions";
import NotesPage from "./NotesPage.vue";

@Component({
  components: {
    NotesPage,
  },
})
export default class ConcussionClinic extends Vue {
  private selectors: SelectorMap;
  private selectorsLoaded = false;

  private hasSymptom(symptom: string) {
    return this.selectors.otherSymptoms.value!.includes(symptom);
  }
}
